import { SagaIterator } from 'redux-saga';
import { fork, takeLatest } from 'redux-saga/effects';
import { SearchActionTypes, ContentActionTypes } from '../actions/ActionTypes';
import { performSearchV2, performSearch } from './PerformSearchSaga';
import { requestContentSlice } from './RequestContentSliceSaga';
import { metricsDataSaga } from './MetricsDataSaga';
import { FeatureFlag, FeatureFlagService } from '../services/FeatureFlagService';

export function* searchResultSaga(): SagaIterator {
  if (FeatureFlagService.instance.getValue(FeatureFlag.smarterSearchEnabled)) {
    yield takeLatest(SearchActionTypes.PERFORM_SEARCH, performSearchV2);
  } else {
    yield takeLatest(SearchActionTypes.PERFORM_SEARCH, performSearch);
  }
  yield takeLatest(ContentActionTypes.REQUEST, requestContentSlice);
  yield fork(metricsDataSaga);
}
